import styled from 'styled-components'

export const RadioWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
`



// WEBPACK FOOTER //
// ./src/pages/Profile/components/BinForm/styles.js